import z from 'zod';
import { UpsertCboRecordRequestSchema } from '@act/shared/data-transfer-objects';

export const CboResourceFormSchema = UpsertCboRecordRequestSchema.extend({
  userNeedId: z.number().int().positive().nullable(),
  address: z.string().optional(),
  /** Set when the user picks a cached/recent CBO row (not shown in the form UI). */
  cboRecordId: z.string().optional().nullable(),
  /** When true, resource is manual entry only (no `cbo_record` / `cbo_usage`). */
  isCustomResource: z.boolean().optional(),
});

export type CboResourceFormValues = z.infer<typeof CboResourceFormSchema>;

export const defaultCboResourceFormValues: CboResourceFormValues = {
  name: '',
  contactName: '',
  phoneNumber: '',
  email: '',
  websiteUrl: '',
  streetAddress: '',
  addressDetails: '',
  city: '',
  state: '',
  zipcode: '',
  formattedAddress: '',
  placeTypes: [],
  categoryLabel: '',
  googlePlaceId: null,
  cboRecordId: null,
  userNeedId: null,
  address: '',
  isCustomResource: false,
};

/**
 * Builds an upsert payload from form values (omitting need selector).
 *
 * @param values - Current form state.
 * @returns Body for `POST /resourcing/cbo-records`.
 */
export function cboFormValuesToUpsertRequest(
  values: CboResourceFormValues
): z.infer<typeof UpsertCboRecordRequestSchema> {
  const addressLine = values.address?.trim();
  return {
    googlePlaceId: values.googlePlaceId,
    name: values.name,
    contactName: values.contactName || null,
    phoneNumber: values.phoneNumber || null,
    email: values.email || null,
    websiteUrl: values.websiteUrl || null,
    streetAddress: values.streetAddress || addressLine || null,
    addressDetails: values.addressDetails || null,
    city: values.city || null,
    state: values.state || null,
    zipcode: values.zipcode || null,
    formattedAddress: values.formattedAddress || addressLine || null,
    placeTypes: values.placeTypes?.length ? values.placeTypes : null,
    categoryLabel: values.categoryLabel || null,
  };
}
